export default "__VITE_ASSET__BLzJCWYY__"